






































import Vue from "vue";

export const ColourWheel = Vue.extend({
  name: "ColourWheel",
  components: {},
  props: {
    SVGHeight: String,
    SVGWidth: String,
    Hue: Number,
    Saturation: Number,
    Light: Number,
  },
  data: function() {
    return {};
  },
  computed: {
    SaturationColor: function() {
      let base255 = Math.floor(this.Light * 2.55);
      let hex = Number(base255).toString(16);
      return `${hex}${hex}${hex}`;
    },
    Hues: function() {
      let allHues = [];
      for (let i = 0; i < 360; i++) {
        let hsl = `hsl(${i}, 100%, ${this.Light}%)`;
        allHues.push(hsl);
      }
      return allHues;
    },
    IndicatorPosition(): [number, number] {
      let satFactor = this.Saturation / 100;
      let x = this.GetX((this.Hue + (this.Hue + 1)) / 2) * satFactor;
      let y = this.GetY((this.Hue + (this.Hue + 1)) / 2) * satFactor;
      return [x, y];
    },
    IndicatorStroke: function() {
      return this.Light < 60 ? "#eeeeff" : "#333350";
    },
  },
  watch: {},
  created() {},
  updated() {},
  mounted() {},
  methods: {
    GetX(index: number): number {
      return Math.sin((index * Math.PI) / 180 + Math.PI) * 100;
    },
    GetY(index: number): number {
      return Math.cos((index * Math.PI) / 180 + Math.PI) * 100;
    },
    GetArc(index: number) {
      let x0 = this.GetX(index);
      let x1 = this.GetX(index + 1);
      let y0 = this.GetY(index);
      let y1 = this.GetY(index + 1);
      let path = `M ${x0} ${y0} A 100 100 0 0 0 ${x1} ${y1} L 0 0`;
      return path;
    },
    GetHSLFromCoords(event: MouseEvent) {
      const colourWheelElement = this.$el.querySelector("#colourWheelCanvas");
      if (!colourWheelElement) return;
      let circleBoundingBox = colourWheelElement.getBoundingClientRect();
      let circleRadius = circleBoundingBox.height / 2;
      let scale = circleRadius / 100;
      let _x = (event.x - circleBoundingBox.x - circleRadius) / scale;
      let _y = (event.y - circleBoundingBox.y - circleRadius) / scale;
      let saturation = Math.sqrt(_x * _x + _y * _y);

      // sin(x)=op

      let x = _x / (saturation / 100);
      let y = _y / (saturation / 100);

      let ang = -(Math.atan2(y, x) + Math.PI / 2);
      if (ang < 0) ang = 2 * Math.PI + ang;
      let hue = (ang * 180) / Math.PI;
      // console.log(ang);

      this.$emit("click", [
        Math.round(hue),
        Math.round(saturation),
        this.Light,
      ]);
    },
  },
});

export default ColourWheel;
